import axios from '@/plugins/axios';

export default {
  async getConfig(): Promise<any> {
    const response = await axios.get('/configuration');
    return response.data;
  },
};
